import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'

import CustomAvatar from '@core/components/mui/avatar'

import { useTRPC } from '@/lib/trpc'

export const Route = createFileRoute('/_dashboard/access-denied')({
  component: AccessDenied
})

/** Where the role guards leave whoever tried to open a restricted area. */
function AccessDenied() {
  const trpc = useTRPC()
  const { data: user } = useQuery(trpc.auth.me.queryOptions())

  return (
    <Card>
      <CardContent className='flex flex-col items-center gap-4 plb-16 text-center'>
        <CustomAvatar skin='light' color='error' variant='rounded' size={56}>
          <i className='tabler-lock text-[30px]' />
        </CustomAvatar>
        <Typography variant='h4'>Acesso restrito</Typography>
        <Typography color='text.secondary' className='max-is-[460px]'>
          {user ? (
            <>
              Você está autenticado como <strong>{user.email}</strong>, mas este é um espaço de operação interna e
              exige papel de administrador.
            </>
          ) : (
            'Esta área exige papel de administrador.'
          )}
        </Typography>
        <Button component={Link} to='/' variant='contained' startIcon={<i className='tabler-arrow-left' />}>
          Voltar ao início
        </Button>
      </CardContent>
    </Card>
  )
}
